import {createContext} from 'react'

import {MarginContext} from './types'

export const Context = createContext<MarginContext | null>(null)
